
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as redirect_45assistantI0euD_NBm3NZyjvTq8L6gD_AZqS9s0Z7Wer6HzrJrlcMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/core/modules/payment/runtime/pages/redirect-assistant.vue?macro=true";
import { default as _91txId_93dmLCRIRaLu2qk28mfNdilOsO5fG7ZW4qofcRCEHwnBAMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/core/modules/payment/runtime/pages/pending/[txId].vue?macro=true";
import { default as modalSD_GI3uPvbFzBe4xJUdyyjQfWewUaEHwH_iCPn7QJxEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/core/modules/promotion/runtime/pages/preview/modal.vue?macro=true";
import { default as _91slug_93tlF_ddneykv_8gKmgpjN1ZqOXdsPput7qYhpzhVfUfEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/games/entrance/[slug].vue?macro=true";
import { default as redirect_45assistantxGafbRF7FwXOzMr6zYKdm8eq_taV1HxEI2_sNPYwba4Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/app/redirect-assistant.vue?macro=true";
import { default as loginTPFfORd0AtHbc7mlAGMDNvxRUcgbu7sZt0fYu_V2icEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/playgame/login.vue?macro=true";
import { default as _91slug_93w4gdCzGyhvSI6xqcuno3LJbaC4rgpa4TiMIHgw15k3wMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93LQe58p3ejrURA7QpH5OuoHl41RdxOx_BjYPBFQGP9yMMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/presse/[slug].vue?macro=true";
import { default as _91token_93_XpUJ4AP8e7w0hVsxY4w83o3_RAEFyu9GRnoRBJmTOcMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/skift-adgangskode/[token].vue?macro=true";
import { default as _91seoName_939ZG6J_fBd4zz5pWgU1sEiDg7HUVYVy6NXuYZvAgaKOIMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/spilside/[seoName].vue?macro=true";
import { default as affiliateaende8iEQsPLd6E0nAfYlOvuQ5Zo0llKiHgLHws0teEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/affiliate.vue?macro=true";
import { default as ansvarligt_45spilJHym9kMnf7SZKwX_cT9koTVFRiRbFcUEjaLVw4wsCroMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/ansvarligt-spil.vue?macro=true";
import { default as bankoanDFQbsD9AYPmfjn0XaDbnErYqc2iWi0PZ3Vkpmsj4UMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/banko.vue?macro=true";
import { default as betingelsercMsuj_M2y2qc93xyf2N3FkAJchmXiD9QoNgqg1_pi7EMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/betingelser.vue?macro=true";
import { default as big_45bassaJgOuVUjj9Hrz6SH7YFFsLfv1DqI5AmCMrc_xCqBAmcMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/big-bass.vue?macro=true";
import { default as bingoLUNhkJAxW_SsZMXJbw_jSqSSR7GblcfT3xz3MG5tD_AMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/bingo.vue?macro=true";
import { default as indexI0WWDu8ZoqJT9Zl0_NpowhV2VgjTgWPSraFOuuYzdWAMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/blog/index.vue?macro=true";
import { default as bonuskode1_a4zpzTnDbWM_v6NFfYftyTX7LJ1A8r7LtdWfRzmRQMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/bonuskode.vue?macro=true";
import { default as casinope4r5y6d5UqW5OTvQjdAP_B_DtszyBr6xeKlR5U2qTsMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/casino.vue?macro=true";
import { default as casino_45lobby72WVKafWig8wmmL3qEH_I9PVt8VJU0k0VLhYwNeXaBoMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/casino-lobby.vue?macro=true";
import { default as cookiepolitikzTzsprM01kB2HB_pj_akmxv_y5MDhUUBcmABe3syCd4Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/cookiepolitik.vue?macro=true";
import { default as faqULyMiawRAvXLT5yAVfhebyn6MM5eptm9VCMt8M8MEm0Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/faq.vue?macro=true";
import { default as jackpot_45slotsLx_PPKs_qfTs2JsdUHN3tQOwN7dZ8iTwtRPR4SCx0dEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/jackpot-slots.vue?macro=true";
import { default as jackpot_45slots_45lobbyLR9TUYRuOo2vKG2JKR8D_AQL5FZQUvwMfebxC7ozSzYMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/jackpot-slots-lobby.vue?macro=true";
import { default as kampagneriNSgmxt8cg8BzCTSMxrwimgE85xALodYYMcFhA_hWJ4Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/kampagner.vue?macro=true";
import { default as _91reportId_93knzZNCrENBYb1bP1XmBMqouRqgQuNdhNM_WKxYf4TPEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/brugerrapport/[reportId].vue?macro=true";
import { default as ansvarligt_45spilHVnKR5nt5FLAc_D4nbJ5bBgQxROZrt4GZ4fO9g4IDqAMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/ansvarligt-spil.vue?macro=true";
import { default as beskederu1ghBH6XxZyoNQ_47j4evy88C0L9qtx4YlH7qxintfEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/beskeder.vue?macro=true";
import { default as biometriJK3D7d_9T0wAhdMBMVvMRerYiRPsa3fLI3iAxxYxcSQMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/biometri.vue?macro=true";
import { default as blokeringo0oG8phjHPDfrEasZC1y0IB75cG8pTQK0RrWRaFs7HEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/blokering.vue?macro=true";
import { default as deaktiveretwcaVHGeoOxFeBVdySEdmrG8qJWIJh344KwWQiB8bbjcMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/deaktiveret.vue?macro=true";
import { default as eidfjh__2jumpOJ0OKhknT0VbPb4Vn_0gewzA5z558BTwgMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/eid.vue?macro=true";
import { default as gemte_45spilaygcY9L73U7_Uw9MseV37VQNAhmJb0LOsvZzFvU5OXYMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/gemte-spil.vue?macro=true";
import { default as hjemNbAIfMVZd59MJZByNW_QKVPpM6nzBYP2Qw4N6aMXHGAMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/hjem.vue?macro=true";
import { default as indbetalFA3_CpIhkwtO5iY4TBfbmEsHDgW2chYBN27LlQpfOHQMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/indbetal.vue?macro=true";
import { default as indbetalingsloftnT1jWO8s1hH4I8cc83v7ya8fSeAXEXP_qV6xeNPhOfkMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/indbetalingsloft.vue?macro=true";
import { default as mine_45bonusserwPbK_xu_ECOnRI_xMVGEsV_z6F91Zt3CWDjR7p8Gk9EMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/mine-bonusser.vue?macro=true";
import { default as nedkoelingJlFOeWyOkID5xjwMQrqQXFyWPm38eVw6nNikKpGu9HcMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/nedkoeling.vue?macro=true";
import { default as ret_45profilkWjaYFEXbrRxVvQh_s4WgrsQyaKh_3_P7EZ_cHW0V9wMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/ret-profil.vue?macro=true";
import { default as sletningRLqqNNtmxbARPYxmwdJyIG42e_O6luP9qP1cykr_sMEMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/sletning.vue?macro=true";
import { default as spaering7L49pWF4JEBEI40aGkkvSueyYtmZpJSZ2EQjwd2irvsMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/spaering.vue?macro=true";
import { default as spilgraenser_45naaetYhe_VffeJBFhElehgmEnVbPK7jN85cFIs9Iq8YRWNV4Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/spilgraenser-naaet.vue?macro=true";
import { default as suspenderet0Dv7JM9snkpRRoGDeE4KsEhAj5U9_x3SDtRJh3DX8z0Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/suspenderet.vue?macro=true";
import { default as udbetaling4ztP4K72k0O_88SNX1ZqXwlHMzKGtTviYjjtOrNX4WoMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/udbetaling.vue?macro=true";
import { default as kontoa9LY4XyKThe1cPUMzeJXYceUCBYBeq03fxcFXAB2QisMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto.vue?macro=true";
import { default as kundeservicek6uyAKxx2E_zCy1khmJzdTyBnPBXn_y_CL8ik5s_CsIMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/kundeservice.vue?macro=true";
import { default as lobbybdzVlxzPWvA4iBx_0gc4EvSrjbqMuKVVVEHf2XIGCBYMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/lobby.vue?macro=true";
import { default as mobil_45appynEUW1zyL0Jau06H09AZg_fkkoP5UL_YE0ZfOWXi2SgMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/mobil-app.vue?macro=true";
import { default as om_45osc30164XrH_AcYh2opfONSYx_LFvq8FDTAeJ_qBOEKTQMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/om-os.vue?macro=true";
import { default as indexenRSTcDAfrSX3SmlfW8WNC4bfTy_AVeICTvVxPH61DMMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/playgame/index.vue?macro=true";
import { default as index0LZR6SKyH4N2H4Opa91StUB0dq3LXlEDN8mmoLHBi6oMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/presse/index.vue?macro=true";
import { default as privatlivspolitikLxUUzwArLYucuq1fkkal1g58GzbG5uwMW0x5O22zlFsMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/privatlivspolitik.vue?macro=true";
import { default as slots_k9gFdrM8F_X3JSV8dLwYYjaTiPL_EOrTc4JR7uava4Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/slots.vue?macro=true";
import { default as slots_45lobbyl4ZMNsDsA1ejdprJ3r9OkgZjoAb8IzLy_I65unXqDLcMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/slots-lobby.vue?macro=true";
import { default as indexA1DYc3QMXZhZMFnULqfvwcRfSwdgqkqGi35kZsmky9EMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/spilleautomater/index.vue?macro=true";
import { default as spiloversigtNNWUV0KXo9iW15K67ct2dhEbu7EtsiOQJh8C3CKWE7IMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/spiloversigt.vue?macro=true";
import { default as spin_45kompassetmm7XwR47vluP4Nu0caZV8Xa3_TXhlTCEr8XGRNW0DSgMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/spin-kompasset.vue?macro=true";
import { default as tvJQofPvXJvSmsKgzlygFIvdsFp4uQYgY7dHwwtk3b2nQMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/tv.vue?macro=true";
import { default as vindere8IPacVP7MyQ0hTuVuju4GWoZaGwdXFHk_Q7Qg6TyXl4Meta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/vindere.vue?macro=true";
import { default as index_6sg3nI9yzWm0eYS85T6_fAEOKSkFQzyE8ecW7GYjjsMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/index.vue?macro=true";
import { default as component_45stubAzryqWfWusGGwTlUUOB13L8nSKmolFiukh__YFJU5RcMeta } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubAzryqWfWusGGwTlUUOB13L8nSKmolFiukh__YFJU5Rc } from "/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "redirect-assistant",
    path: "/payments/redirect-assistant",
    meta: redirect_45assistantI0euD_NBm3NZyjvTq8L6gD_AZqS9s0Z7Wer6HzrJrlcMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/core/modules/payment/runtime/pages/redirect-assistant.vue")
  },
  {
    name: "payments-pending",
    path: "/payments/pending/:txId",
    meta: _91txId_93dmLCRIRaLu2qk28mfNdilOsO5fG7ZW4qofcRCEHwnBAMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/core/modules/payment/runtime/pages/pending/[txId].vue")
  },
  {
    name: "preview-promotions-modal",
    path: "/preview/promotions/modal",
    meta: modalSD_GI3uPvbFzBe4xJUdyyjQfWewUaEHwH_iCPn7QJxEMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/core/modules/promotion/runtime/pages/preview/modal.vue")
  },
  {
    name: "games-entrance-slug",
    path: "/games/entrance/:slug()",
    meta: { ...(_91slug_93tlF_ddneykv_8gKmgpjN1ZqOXdsPput7qYhpzhVfUfEMeta || {}), ...{"middleware":["entrance"]} },
    alias: ["/spil/:slug","/spilleautomater/entrance/:slug"],
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/games/entrance/[slug].vue")
  },
  {
    name: "app-redirect-assistant",
    path: "/app/redirect-assistant",
    meta: redirect_45assistantxGafbRF7FwXOzMr6zYKdm8eq_taV1HxEI2_sNPYwba4Meta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/app/redirect-assistant.vue")
  },
  {
    name: "playgame-login",
    path: "/playgame/login",
    meta: { ...(loginTPFfORd0AtHbc7mlAGMDNvxRUcgbu7sZt0fYu_V2icEMeta || {}), ...{"middleware":["playgame-login"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/playgame/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93w4gdCzGyhvSI6xqcuno3LJbaC4rgpa4TiMIHgw15k3wMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/blog/[slug].vue")
  },
  {
    name: "presse-slug",
    path: "/presse/:slug()",
    meta: _91slug_93LQe58p3ejrURA7QpH5OuoHl41RdxOx_BjYPBFQGP9yMMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/presse/[slug].vue")
  },
  {
    name: "skift-adgangskode-token",
    path: "/skift-adgangskode/:token()",
    meta: { ...(_91token_93_XpUJ4AP8e7w0hVsxY4w83o3_RAEFyu9GRnoRBJmTOcMeta || {}), ...{"middleware":["guest-only"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/skift-adgangskode/[token].vue")
  },
  {
    name: "spilside-seoName",
    path: "/spilside/:seoName()",
    meta: _91seoName_939ZG6J_fBd4zz5pWgU1sEiDg7HUVYVy6NXuYZvAgaKOIMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/spilside/[seoName].vue")
  },
  {
    name: "affiliate",
    path: "/affiliate",
    meta: affiliateaende8iEQsPLd6E0nAfYlOvuQ5Zo0llKiHgLHws0teEMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/affiliate.vue")
  },
  {
    name: "ansvarligt-spil",
    path: "/ansvarligt-spil",
    meta: ansvarligt_45spilJHym9kMnf7SZKwX_cT9koTVFRiRbFcUEjaLVw4wsCroMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/ansvarligt-spil.vue")
  },
  {
    name: "banko",
    path: "/banko",
    meta: bankoanDFQbsD9AYPmfjn0XaDbnErYqc2iWi0PZ3Vkpmsj4UMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/banko.vue")
  },
  {
    name: "betingelser",
    path: "/betingelser",
    meta: betingelsercMsuj_M2y2qc93xyf2N3FkAJchmXiD9QoNgqg1_pi7EMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/betingelser.vue")
  },
  {
    name: "big-bass",
    path: "/big-bass",
    meta: { ...(big_45bassaJgOuVUjj9Hrz6SH7YFFsLfv1DqI5AmCMrc_xCqBAmcMeta || {}), ...{"middleware":["landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/big-bass.vue")
  },
  {
    name: "bingo",
    path: "/bingo",
    meta: bingoLUNhkJAxW_SsZMXJbw_jSqSSR7GblcfT3xz3MG5tD_AMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/bingo.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexI0WWDu8ZoqJT9Zl0_NpowhV2VgjTgWPSraFOuuYzdWAMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/blog/index.vue")
  },
  {
    name: "bonuskode",
    path: "/bonuskode",
    meta: {"middleware":["guest-only"]},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/bonuskode.vue")
  },
  {
    name: "casino",
    path: "/casino",
    meta: casinope4r5y6d5UqW5OTvQjdAP_B_DtszyBr6xeKlR5U2qTsMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/casino.vue")
  },
  {
    name: "casino-lobby",
    path: "/casino-lobby",
    meta: casino_45lobby72WVKafWig8wmmL3qEH_I9PVt8VJU0k0VLhYwNeXaBoMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/casino-lobby.vue")
  },
  {
    name: "cookiepolitik",
    path: "/cookiepolitik",
    meta: cookiepolitikzTzsprM01kB2HB_pj_akmxv_y5MDhUUBcmABe3syCd4Meta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/cookiepolitik.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: faqULyMiawRAvXLT5yAVfhebyn6MM5eptm9VCMt8M8MEm0Meta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/faq.vue")
  },
  {
    name: "jackpot-slots",
    path: "/jackpot-slots",
    meta: jackpot_45slotsLx_PPKs_qfTs2JsdUHN3tQOwN7dZ8iTwtRPR4SCx0dEMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/jackpot-slots.vue")
  },
  {
    name: "jackpot-slots-lobby",
    path: "/jackpot-slots-lobby",
    meta: jackpot_45slots_45lobbyLR9TUYRuOo2vKG2JKR8D_AQL5FZQUvwMfebxC7ozSzYMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/jackpot-slots-lobby.vue")
  },
  {
    name: "kampagner",
    path: "/kampagner",
    meta: { ...(kampagneriNSgmxt8cg8BzCTSMxrwimgE85xALodYYMcFhA_hWJ4Meta || {}), ...{"middleware":["promotions"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/kampagner.vue")
  },
  {
    name: "konto",
    path: "/konto",
    meta: { ...(kontoa9LY4XyKThe1cPUMzeJXYceUCBYBeq03fxcFXAB2QisMeta || {}), ...{"groups":["konto"],"middleware":["require-auth"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto.vue"),
    children: [
  {
    name: "konto-brugerrapport-reportId",
    path: "brugerrapport/:reportId()",
    meta: { ...(_91reportId_93knzZNCrENBYb1bP1XmBMqouRqgQuNdhNM_WKxYf4TPEMeta || {}), ...{"groups":["konto","ansvarligtspil"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/brugerrapport/[reportId].vue")
  },
  {
    name: "konto-ansvarligt-spil",
    path: "ansvarligt-spil",
    meta: { ...(ansvarligt_45spilHVnKR5nt5FLAc_D4nbJ5bBgQxROZrt4GZ4fO9g4IDqAMeta || {}), ...{"groups":["konto","ansvarligtspil"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/ansvarligt-spil.vue")
  },
  {
    name: "konto-beskeder",
    path: "beskeder",
    meta: { ...(beskederu1ghBH6XxZyoNQ_47j4evy88C0L9qtx4YlH7qxintfEMeta || {}), ...{"groups":["konto"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/beskeder.vue")
  },
  {
    name: "konto-biometri",
    path: "biometri",
    meta: { ...(biometriJK3D7d_9T0wAhdMBMVvMRerYiRPsa3fLI3iAxxYxcSQMeta || {}), ...{"groups":["konto"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/biometri.vue")
  },
  {
    name: "konto-blokering",
    path: "blokering",
    meta: { ...(blokeringo0oG8phjHPDfrEasZC1y0IB75cG8pTQK0RrWRaFs7HEMeta || {}), ...{"groups":["konto","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/blokering.vue")
  },
  {
    name: "konto-deaktiveret",
    path: "deaktiveret",
    meta: { ...(deaktiveretwcaVHGeoOxFeBVdySEdmrG8qJWIJh344KwWQiB8bbjcMeta || {}), ...{"groups":["konto","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/deaktiveret.vue")
  },
  {
    name: "konto-eid",
    path: "eid",
    meta: { ...(eidfjh__2jumpOJ0OKhknT0VbPb4Vn_0gewzA5z558BTwgMeta || {}), ...{"groups":["konto"],"middleware":["require-auth"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/eid.vue")
  },
  {
    name: "konto-gemte-spil",
    path: "gemte-spil",
    meta: { ...(gemte_45spilaygcY9L73U7_Uw9MseV37VQNAhmJb0LOsvZzFvU5OXYMeta || {}), ...{"groups":["konto"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/gemte-spil.vue")
  },
  {
    name: "konto-hjem",
    path: "hjem",
    meta: { ...(hjemNbAIfMVZd59MJZByNW_QKVPpM6nzBYP2Qw4N6aMXHGAMeta || {}), ...{"groups":["konto"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/hjem.vue")
  },
  {
    name: "konto-indbetal",
    path: "indbetal",
    meta: { ...(indbetalFA3_CpIhkwtO5iY4TBfbmEsHDgW2chYBN27LlQpfOHQMeta || {}), ...{"groups":["konto"],"middleware":["clean-view-param"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/indbetal.vue")
  },
  {
    name: "konto-indbetalingsloft",
    path: "indbetalingsloft",
    meta: { ...(indbetalingsloftnT1jWO8s1hH4I8cc83v7ya8fSeAXEXP_qV6xeNPhOfkMeta || {}), ...{"groups":["konto","ansvarligtspil"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/indbetalingsloft.vue")
  },
  {
    name: "konto-mine-bonusser",
    path: "mine-bonusser",
    meta: { ...(mine_45bonusserwPbK_xu_ECOnRI_xMVGEsV_z6F91Zt3CWDjR7p8Gk9EMeta || {}), ...{"groups":["konto"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/mine-bonusser.vue")
  },
  {
    name: "konto-nedkoeling",
    path: "nedkoeling",
    meta: { ...(nedkoelingJlFOeWyOkID5xjwMQrqQXFyWPm38eVw6nNikKpGu9HcMeta || {}), ...{"groups":["konto","ansvarligtspil"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/nedkoeling.vue")
  },
  {
    name: "konto-ret-profil",
    path: "ret-profil",
    meta: { ...(ret_45profilkWjaYFEXbrRxVvQh_s4WgrsQyaKh_3_P7EZ_cHW0V9wMeta || {}), ...{"groups":["konto"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/ret-profil.vue")
  },
  {
    name: "konto-sletning",
    path: "sletning",
    meta: { ...(sletningRLqqNNtmxbARPYxmwdJyIG42e_O6luP9qP1cykr_sMEMeta || {}), ...{"groups":["konto","ansvarligtspil"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/sletning.vue")
  },
  {
    name: "konto-spaering",
    path: "spaering",
    meta: { ...(spaering7L49pWF4JEBEI40aGkkvSueyYtmZpJSZ2EQjwd2irvsMeta || {}), ...{"groups":["konto","ansvarligtspil"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(ansvarligt-spil)/spaering.vue")
  },
  {
    name: "konto-spilgraenser-naaet",
    path: "spilgraenser-naaet",
    meta: { ...(spilgraenser_45naaetYhe_VffeJBFhElehgmEnVbPK7jN85cFIs9Iq8YRWNV4Meta || {}), ...{"groups":["konto","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/spilgraenser-naaet.vue")
  },
  {
    name: "konto-suspenderet",
    path: "suspenderet",
    meta: { ...(suspenderet0Dv7JM9snkpRRoGDeE4KsEhAj5U9_x3SDtRJh3DX8z0Meta || {}), ...{"groups":["konto","restrictedaccess"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/(restricted-access)/suspenderet.vue")
  },
  {
    name: "konto-udbetaling",
    path: "udbetaling",
    meta: { ...(udbetaling4ztP4K72k0O_88SNX1ZqXwlHMzKGtTviYjjtOrNX4WoMeta || {}), ...{"groups":["konto"],"middleware":["require-eid"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/(konto)/konto/udbetaling.vue")
  }
]
  },
  {
    name: "kundeservice",
    path: "/kundeservice",
    meta: kundeservicek6uyAKxx2E_zCy1khmJzdTyBnPBXn_y_CL8ik5s_CsIMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/kundeservice.vue")
  },
  {
    name: "lobby",
    path: "/lobby",
    meta: { ...(lobbybdzVlxzPWvA4iBx_0gc4EvSrjbqMuKVVVEHf2XIGCBYMeta || {}), ...{"middleware":["recurring-consent"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/lobby.vue")
  },
  {
    name: "mobil-app",
    path: "/mobil-app",
    meta: mobil_45appynEUW1zyL0Jau06H09AZg_fkkoP5UL_YE0ZfOWXi2SgMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/mobil-app.vue")
  },
  {
    name: "om-os",
    path: "/om-os",
    meta: om_45osc30164XrH_AcYh2opfONSYx_LFvq8FDTAeJ_qBOEKTQMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/om-os.vue")
  },
  {
    name: "playgame",
    path: "/playgame",
    meta: { ...(indexenRSTcDAfrSX3SmlfW8WNC4bfTy_AVeICTvVxPH61DMMeta || {}), ...{"middleware":["playgame"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/playgame/index.vue")
  },
  {
    name: "presse",
    path: "/presse",
    meta: index0LZR6SKyH4N2H4Opa91StUB0dq3LXlEDN8mmoLHBi6oMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/presse/index.vue")
  },
  {
    name: "privatlivspolitik",
    path: "/privatlivspolitik",
    meta: privatlivspolitikLxUUzwArLYucuq1fkkal1g58GzbG5uwMW0x5O22zlFsMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/privatlivspolitik.vue")
  },
  {
    name: "slots",
    path: "/slots",
    meta: { ...(slots_k9gFdrM8F_X3JSV8dLwYYjaTiPL_EOrTc4JR7uava4Meta || {}), ...{"middleware":["landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/slots.vue")
  },
  {
    name: "slots-lobby",
    path: "/slots-lobby",
    meta: slots_45lobbyl4ZMNsDsA1ejdprJ3r9OkgZjoAb8IzLy_I65unXqDLcMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/slots-lobby.vue")
  },
  {
    name: "spilleautomater",
    path: "/spilleautomater",
    meta: indexA1DYc3QMXZhZMFnULqfvwcRfSwdgqkqGi35kZsmky9EMeta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/spilleautomater/index.vue")
  },
  {
    name: "spiloversigt",
    path: "/spiloversigt",
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/spiloversigt.vue")
  },
  {
    name: "spin-kompasset",
    path: "/spin-kompasset",
    meta: { ...(spin_45kompassetmm7XwR47vluP4Nu0caZV8Xa3_TXhlTCEr8XGRNW0DSgMeta || {}), ...{"middleware":["landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/spin-kompasset.vue")
  },
  {
    name: "tv",
    path: "/tv",
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/tv.vue")
  },
  {
    name: "vindere",
    path: "/vindere",
    meta: vindere8IPacVP7MyQ0hTuVuju4GWoZaGwdXFHk_Q7Qg6TyXl4Meta || {},
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@spilnu/dk/app/pages/vindere.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index_6sg3nI9yzWm0eYS85T6_fAEOKSkFQzyE8ecW7GYjjsMeta || {}), ...{"middleware":["landing-page"]} },
    component: () => import("/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/app/pages/index.vue")
  },
  {
    name: component_45stubAzryqWfWusGGwTlUUOB13L8nSKmolFiukh__YFJU5RcMeta?.name,
    path: "/offer-me",
    component: component_45stubAzryqWfWusGGwTlUUOB13L8nSKmolFiukh__YFJU5Rc
  }
]